export default __webpack_public_path__ + "static/media/gm-net-girl.2c5664f6.webp";